export const DailyTestLogConstants = {
    GET_ALL_DAILY_TEST_LOG_SUCCESS: "GET_ALL_DAILY_TEST_LOG_SUCCESS",
    GET_ALL_DAILY_TEST_LOG_ERROR: "GET_ALL_DAILY_TEST_LOG_ERROR",
    ALL_DAILY_TEST_LOG_LOADING: "ALL_DAILY_TEST_LOG_LOADING",
};
